
function Harbour() {

    return (
        <div>
            <main>
                <section>
                    <div className="banner">
                        <img className='header-image' src="/assets/coast-img/harbour_banner.JPG" alt="Hafen" />
                    </div>
                </section>
                <div className="content">
                    <article>
                        <div className="text">
                            <h1>Alter Hafen</h1>
                            <p>Bereits im 13. Jhd. entstanden, reicht die Historie des Wismarer Hafens lange zurück. Damals 
                                Handels- und Umschlagplatz, heute Sehenswürdigkeit und Ort vieler kleiner Läden und Restaurants. 
                                Startpunkt für Bootstouren oder Ankerplatz für das eigene schwimmende Glück. Die riesigen und 
                                liebevoll restaurierten Silobauten, die als Getreidespeicher dienten, lassen die Warenmengen 
                                erahnen, die in den Hochzeiten des Handels auf dem Wasserweg in der kleinen Stadt umgeschlagen 
                                wurden.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Baumhaus</h2>
                            <p>Ein Häuschen aus der Mitte des 18. Jhd., inmitten der Hafenspitze. Hier arbeiteten damals die 
                                Bohmschlüter, deren Aufgabe es war, die Hafeneinfahrt zur Nacht oder bei drohender Gefahr mit 
                                einem schwimmenden Baum zu verschließen.<br></br>Heute zieren zwei Schwedenköpfe den Eingang 
                                des Gebäudes, ebenfalls ein typisches Wahrzeichen für die Hansestadt, die Ende des 17. Jhd. unter
                                schwedischer Herrschaft stand.
                            </p>
                        </div>
                        <div className="text">
                            <h2>Seeperle</h2>
                            <p>Das absolute Fischparadies. Für den kleinen Hunger zwischendurch oder als satte Mittagsmahlzeit. 
                                Für Fischkenner und solche, die es werden wollen. Das Restaurant befindet sich südwestlich vom 
                                Alten Hafen, gegenüber des "schiefen" Gewölbehauses. Hier lassen sich auch kleine Imbisse einnehmen 
                                oder Fisch-Snacks von der Fischtheke mit nach Hause nehmen.<br></br>Auf der Webseite der Seeperle 
                                vorbeischauen lohnt sich übrigens, die Fischauswahl ist riesig.
                            </p>
                        </div>
                    </article>
                </div>
            </main>
        </div>
    )
}

export default Harbour;